export const workspace = {
  routes: [
    {
      path: "/workspace/library/disposal-method",
      component: () => import("../disposal-method/workspace-library-disposal-method-view"),
    },
    {
      path: "/workspace/library/physical-storage-category",
      component: () => import("../physical-storage/workspace-library-physical-storage-category-view"),
    },
    {
      path: "/workspace/library/physical-storage",
      component: () => import("../physical-storage/workspace-library-physical-storage-view"),
    },
    {
      path: "/workspace/library/electronic-storage",
      component: () => import("../electronic-storage/workspace-library-electronic-storage-view"),
    },
    {
      path: "/workspace/library/electronic-storage-category",
      component: () => import("../electronic-storage/workspace-library-electronic-storage-category-view"),
    },
  ],
};

export const management = {
  routes: [
  ],
};
